const HASHTAG_TYPE = "wix-draft-plugin-hashtag";
export {
  HASHTAG_TYPE
};
//# sourceMappingURL=types.js.map
